import '.././App.css';
import '../Styles/MainPage.css';
import '../Styles/AboutPage.css';

import Img_MyPortrait from '../Images/Illustrations/MyPortrait.png';


function AboutPage() {

    const getAge = () => {
        const bDay = new Date('3/21/1999');
        const today = new Date();
        let age = today.getFullYear() - bDay.getFullYear() - 1;
        if(
            today.getMonth() > bDay.getMonth() || 
            (today.getMonth() === bDay.getMonth() && today.getDate() >= bDay.getDate())
            ){
            age++;
        }
        return age;        
    }

    return(
        <>
        <div className='aboutContainer'>
            <div className='aboutHeader'>
                <img src={Img_MyPortrait} alt='portrait'/>
                <h2>About me</h2>
            </div>

            <div className='aboutDescription'>
                <p>I'm {getAge()} years old software engineer and digital artist from Ukraine. 
                Currently I work as a full-stack developer for Masslight Inc and also design and develop my own projects in free time.</p>

                <p>My developer story started when I was about 15 years old with mod-making for Skyrim. 
                    That brought me understanding of basics of game structure and scripting. 
                    Later I’ve got into college and received degrees in software and computer engineering.
                    During education I also was learning Unreal Engine 4 and practicing it in my own pet-projects. </p>

                <p>At the moment I have few published non-commercial android projects, few game asset-packs and a lot of different artworks made with various tools and software.</p>

                <p>If you'd like to contact or follow me on social media, please take a look at links attached to the footer.</p>
            </div>
        </div>
            
            
        </>
    );

}

export default AboutPage;